import {Component, OnDestroy, OnInit} from "@angular/core";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {IScene, IStory} from "../../services/factory-service-impl/story.utils";
import {SCENE_TYPES} from "../../enums/e-scene-types";
import {isUndefined} from "util";
import {localeUtils} from "../../helpers/locale-utils";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {WatchService} from "../../services/watch.service";
import {Subject} from "rxjs/Subject";


@Component({
  selector: 'app-story-page',
  templateUrl: "./stories-page.component.html",
  styles:[]
})
export class StoryComponent implements OnInit, OnDestroy{
  UI_TEXTS = UI_TEXTS;
   pageParams = paramsHelper.page()
    .setTitle("Сюжет");


  document:IStory;
  helpers = {
    getLabel:this.doGetLabel
  };
  private unsubscribe: Subject<void> = new Subject<void>();

  collectionParams = paramsHelper.collection()
    //.setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQueryHelpers(this.helpers)
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
    .setObjectType(DOCUMENT_TYPES.STORY)
    .setSearchParams(paramsHelper.search()
      .addParam(`scenes.params.talk.locales.${localeUtils.getLocale()}.speech`, SEARCH_PROP_TYPES.LOCALE, ""));
      //.addParam(`${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, ""));



  constructor(private busService: BusService, private watchService:WatchService) {
  }

  ngOnInit(){
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.updateDocument(e.document as IStory));

    this.watchService.docChanged()
      .takeUntil(this.unsubscribe)
      .subscribe(hasChanges => {
        if (hasChanges)
        {
          this.updateDocument(this.document);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private doGetLabel(scene:IScene):string{
    if (!isUndefined(scene))
    {
      if (scene.type == SCENE_TYPES.COMICS)
      {
        if (!isUndefined(scene.params["slides"])
          && !isUndefined(scene.params["slides"][0]))
        {
          return localeUtils.findValue("text", scene.params["slides"][0]);
        }
        else
        {
          return "Пустой комикс";
        }
      }
      else
      {
        if (!isUndefined(scene.params["talk"])
          && !isUndefined(scene.params["talk"][0]))
        {
          return localeUtils.findValue("speech", scene.params["talk"][0]);
        }
        else
        {
          return "Пустой диалог";
        }
      }
    }
    else
    {
      return "Пустой";
    }
  }

  private updateDocument(document:IStory){
    //console.log(document);
    this.document = document;
    if (document !== null)
    {
      if (isUndefined(this.document['locales']))
      {
        this.document['locales'] = {};
      }
      this.document['locales'][localeUtils.getLocale()] = [{key:"name", value:[this.doGetLabel(document.scenes[0])]}];
      //console.log(this.document['locales'][localeUtils.getLocale()]);
    }
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/stories/stories-page.component.ts